import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css'
import './styles/ckeditor.css'
import { AppProviders } from './context'
import { getEnv } from 'utils/env'
import LogRocket from 'logrocket'
const { LOG_ROCKET_PROJECT_ID } = getEnv()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (LOG_ROCKET_PROJECT_ID) {
  LogRocket.init(LOG_ROCKET_PROJECT_ID)
}

root.render(
  <AppProviders>
    <App />
  </AppProviders>,
)
